import React from 'react'

const ContentArea = (props) => {
    const className = props.className ? `content-area overflow-auto ${props.className}` : 'content-area overflow-auto'
    return (
        <div className={className}>{props.children}</div>
    )
}

export default ContentArea